<template>
  <div>
    <template v-if="!$store.state.map.show">
      <v-row no-gutters style="height: 63px" class="px-3" justify="start" align="center">
        <img
          style="height: 23px;"
          src="https://file.usail.es/static/fleet-commander-logo-black.svg"
          alt="USAIL Fleet Commander"
        />
      </v-row>
      <v-divider></v-divider>
    </template>

    <div
      v-if="userInfo && userProfile && $store.state.map.show"
      class="pa-3"
      @click="$emit('showUserProfileUpdateDialog', userProfile)"
    >
      <v-avatar size="50" class="mr-2">
        <img
          v-if="userProfile && userProfile.image"
          :src="userProfile.image.contentUrl + '?x-request=html'"
          :alt="userInfo.name"
        />
        <img v-else src="../assets/no-img.svg" />
      </v-avatar>
      <div>
        <span class="title">{{ userInfo.name }}</span>
        <br />
        <span class="grey--text">{{ userInfo.email }}</span>
      </div>
    </div>

    <v-list class="pt-0" dense nav>
      <template v-if="$store.state.map.show">
        <v-divider></v-divider>

        <v-list-item key="my-account" @click="$emit('showUserProfileUpdateDialog', userProfile)">
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t('message.my_account') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item key="logout" @click="$router.push({ name: 'logout' })">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t('message.logout') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </template>

      <v-subheader>{{ $t('message.organizations') }}</v-subheader>

      <v-list-item
        v-for="organization in organizations"
        :key="organization.id"
        link
        :to="{
          name: $store.state.map.show ? 'OrganizationShowMap' : 'OrganizationShow',
          params: { id: $iriToId(organization['@id']) }
        }"
      >
        <v-list-item-icon>
          <v-icon>mdi-domain</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ organization.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-subheader>{{ $t('message.vessels') }}</v-subheader>

      <v-list-item
        v-for="vessel in vessels"
        :key="vessel.id"
        :to="{
          name: $store.state.map.show ? 'VesselShowMap' : 'VesselShow',
          params: { id: $iriToId(vessel['@id']) }
        }"
      >
        <v-list-item-icon>
          <v-icon>mdi-ferry</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ vessel.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-if="false === $store.state.map.show && userProfile">
        <v-subheader>{{ userProfile.firstName }} {{ userProfile.lastName }}</v-subheader>

        <v-list-item key="my-account" @click="$emit('showUserProfileUpdateDialog', userProfile)">
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t('message.my_account') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item key="logout" @click="$router.push({ name: 'logout' })">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t('message.logout') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import fetch from '@/utils/fetch'

export default {
  props: {
    drawer: {
      type: Boolean,
      required: false,
      default: false
    },
    userInfo: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data() {
    return {
      organizations: null,
      vessels: null
    }
  },

  computed: {
    ...mapGetters({
      organizationCreated: 'organization/create/created',
      organizationUpdated: 'organization/update/updated',
      organizationDeleted: 'organization/del/deleted',
      vesselCreated: 'vessel/create/created',
      vesselUpdated: 'vessel/update/updated',
      vesselDeleted: 'vessel/del/deleted',
      userProfile: 'userprofile/show/retrieved',
      userProfileLoading: 'userprofile/show/isLoading',
      userProfileError: 'userprofile/show/error'
    })
  },

  watch: {
    organizationCreated: function() {
      this.fetchOrganizations()
    },
    organizationUpdated: function() {
      this.fetchOrganizations()
    },
    organizationDeleted: function() {
      this.fetchOrganizations()
    },
    vesselCreated: function() {
      this.fetchVessels()
    },
    vesselUpdated: function() {
      this.fetchVessels()
    },
    vesselDeleted: function() {
      this.fetchVessels()
    }
  },

  mounted() {
    this.getUserProfile('/users/' + this.userInfo.sub)
    this.fetchOrganizations()
    this.fetchVessels()
  },

  methods: {
    ...mapActions({
      getOrganizations: 'organization/list/default',
      getVessels: 'vessel/list/default',
      getUserProfile: 'userprofile/show/retrieve'
    }),

    fetchOrganizations() {
      fetch('/organizations?pagination=false&dealer=false')
        .then(response => response.json())
        .then(data => {
          this.organizations = data['hydra:member']
        })
        .catch(e => {
          // eslint-disable-next-line
          console.log(e)
        })
    },

    fetchVessels() {
      fetch('/vessels?pagination=false&archived=false')
        .then(response => response.json())
        .then(data => {
          this.vessels = data['hydra:member']
        })
        .catch(e => {
          // eslint-disable-next-line
          console.log(e)
        })
    }
  }
}
</script>
